module.exports = __webpack_public_path__ + "img/1553624931.8b2d5e21.jpg";